module.exports = __webpack_public_path__ + "static/media/listMySpace.faeebe64.svg";